// extracted by mini-css-extract-plugin
export default {"btn":"btn___P3LyP","register":"register___o0OW_","sign":"sign___Y55tm","title":"title___X6FBc","container":"container___Kta6c"};